import { Environment } from 'src/Environment';
import { Api } from 'src/common';
import { removeNonNumericCharacters } from 'src/helpers/formatting';

type OtpResponse = {
  ok: boolean;
  status: number;
  sendAttempts: number;
  data: {
    type: string;
    address: string;
    success: boolean;
    verifyAttemts: number; /* not a typo */
    message: string;
  }
}

export async function requestSmsOtp(phoneNumber?: string) {
  const phoneNumberCleaned = removeNonNumericCharacters(phoneNumber);

  const { response } = await Api.post<OtpResponse>(
    `${Environment.current?.otpApiBaseURL}MOB/${phoneNumberCleaned}`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify([{ type: 'SMS', message: 'message', address: phoneNumberCleaned }]),
    },
  );

  return {
    error: response.status === 200 ? null : response.data.message || 'We’re sorry, but we’re experiencing technical difficulties. Please try again.',
  };
}

export async function validateOtp(phoneNumber: string, otp: string) {
  const phoneNumberCleaned = removeNonNumericCharacters(phoneNumber);

  const { response } = await Api.get<OtpResponse>(
    `${Environment.current?.otpApiBaseURL}MOB/${phoneNumberCleaned}/${otp}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
    },
  );
  return {
    error: response.status === 200 ? null : response.data.message || 'We’re sorry, but we’re experiencing technical difficulties. Please try again.',
  };
}
